var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded-circle bg-dark text-white px-2 py-1"},[_vm._v("\n    "+_vm._s(_vm.total)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }